import { render, staticRenderFns } from "./Subject3.vue?vue&type=template&id=384b064a&scoped=true"
import script from "./Subject3.vue?vue&type=script&lang=js"
export * from "./Subject3.vue?vue&type=script&lang=js"
import style0 from "./Subject3.vue?vue&type=style&index=0&id=384b064a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b064a",
  null
  
)

export default component.exports